var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "barcode"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1755_42026",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1755_42026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "barcode_2",
    d: "M1.1665 22.1654V5.83203H3.49984V22.1654H1.1665ZM4.6665 22.1654V5.83203H6.99984V22.1654H4.6665ZM8.1665 22.1654V5.83203H9.33317V22.1654H8.1665ZM11.6665 22.1654V5.83203H13.9998V22.1654H11.6665ZM15.1665 22.1654V5.83203H18.6665V22.1654H15.1665ZM19.8332 22.1654V5.83203H20.9998V22.1654H19.8332ZM23.3332 22.1654V5.83203H26.8332V22.1654H23.3332Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarcode);
export default __webpack_public_path__ + "static/media/icon_barcode.35d85b49f9bf1e075e9d35cffb4d5b61.svg";
export { ForwardRef as ReactComponent };